import createScript from './create-script';

const injectJsSources = (targetDocument, dependencies, attributes = {}, target) => {
  const attributesEntry = Object.entries(attributes);

  dependencies.forEach((src) => {
    if (targetDocument.querySelector(`script[src="${src}"]`)) return;

    const script = createScript(targetDocument, src);

    attributesEntry.forEach(([attributeName, attributeValue]) => {
      script.setAttribute(attributeName, attributeValue);
    });

    target.element.insertAdjacentElement(target.position, script);
  });
};

export default injectJsSources;
